import Permission from '@/enums/Permission';
import type { SharedData } from '@/types';
import { usePage } from '@inertiajs/vue3';

export function usePermissions() {
    const page = usePage<SharedData>();

    const hasPermission = (permission: Permission): boolean => {
        return page.props.auth.user.permissions.includes(permission);
    };

    const hasAnyPermission = (permissions: Permission[]): boolean => {
        return permissions.some((permission) => hasPermission(permission));
    };

    const hasAllPermissions = (permissions: Permission[]): boolean => {
        return permissions.every((permission) => hasPermission(permission));
    };

    return {
        hasPermission,
        hasAnyPermission,
        hasAllPermissions,
    };
}
